import styled from "styled-components";

export const StyledMarkdown = styled.div`
  white-space: pre-wrap;
`;
